import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "../../components";
import { editBiodata } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSuccess } from "../../helpers/Toast";

const EditProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { nama, alamat, email, no_hp } = location.state || {};
  const [emailuser, setemailuser] = useState(email || "");
  const [nohpuser, setnohpuser] = useState(no_hp || "");
  const [alamatuser, setalamatuser] = useState(alamat || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = { nama, email: emailuser, no_hp: nohpuser, alamat: alamatuser };

    try {
      setIsSubmitting(true);
      const response = await fetch(editBiodata, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        showError(JSON.stringify(errorData.errors).replace(/["{}]/g, "").replace(/:/, ": "));
        return;
      }
      showSuccess("Profil berhasil diperbarui");
      navigate("/profile");
    } catch (error) {
      showError("Gagal memperbarui profil");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputClass =
    "w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/30 transition";

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Edit Profil</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/profile" title="Edit Profil" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-4 space-y-4">
            {/* Nama (readonly) */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Nama</label>
              <input
                value={nama || ""}
                readOnly
                className="w-full rounded-xl border border-gray-100 bg-gray-100 px-4 py-2.5 text-sm text-gray-500 cursor-not-allowed"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Email</label>
              <input
                value={emailuser}
                onChange={(e) => setemailuser(e.target.value)}
                type="email"
                placeholder="Masukkan email"
                className={inputClass}
              />
            </div>

            {/* No HP */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">No. HP</label>
              <input
                value={nohpuser}
                onChange={(e) => setnohpuser(e.target.value)}
                type="tel"
                placeholder="Masukkan nomor HP"
                className={inputClass}
              />
            </div>

            {/* Alamat */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Alamat</label>
              <textarea
                value={alamatuser}
                onChange={(e) => setalamatuser(e.target.value)}
                placeholder="Masukkan alamat"
                rows={3}
                className={`${inputClass} resize-none`}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex items-center justify-center gap-2 rounded-2xl py-3.5 text-sm font-bold text-white shadow-md transition active:scale-95 disabled:opacity-70"
            style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
          >
            {isSubmitting ? (
              <>
                <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Menyimpan...
              </>
            ) : "Simpan Perubahan"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
